import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { hartfordConfig } from "./data";

export default function HartfordPage() {
  return <CityPageTemplate config={hartfordConfig} />;
}